<template lang="pug">
.features.address-info.sr-info.download-info
  .address-container
    .columns.aic
      .column.is-flex.aic.jcc
        .feature
          p
            img.img-miner(:src="'/img/ios-app/app-' + mode + '.png'")
            .feature-helvetica

      .column.aic.is-flex.fdc
        .feature.mt-10.title-desc
          span.title.text-white-on-dark Keep 
          span.title.pink track 
          span.title.text-white-on-dark of your 
          span.title.pink earnings
          span.title.text-white-on-dark , monitor multiple addresses at the same time and more.

        .feature.mb-5.fw-400.mt-20
          .referral-template-home.has-text-left
            p.fs-15.fw-700 Version {{ current.versionNumber }} 
            p.fs-10.mb-10 {{ current.buildDate }}
            ul.mb-10
              li.new-feature-li
                b Our Android App is now available!
              li.new-feature-li Review your balance across all your addresses.
              li.new-feature-li Check your active algorithms in one place.
              li.new-feature-li Manage your payments.
              li.new-feature-li Stay up to date with the latest news.
              li.new-feature-li Support for Light and Dark theme.
        .flex.aic.mt-10
          a.get-app-image.android(href="https://play.google.com/store/apps/details?id=com.unmineable.mobileapp", target="_blank")
            img(src="/img/app-store-badge-android.png")
          a.get-app-image(href="https://apps.apple.com/pe/app/unmineable/id6444838563", target="_blank")
            img(src="/img/app-store-badge.svg")

    .feature.feature-helvetica.has-text-left

      hr
      p.smaller-content (*) 
        b.w400 Note that our monitoring app is not capable of crypto mining, you must be mining with a computer or ASIC device to monitor your progress.

</template>

<script>
export default {
  name: 'view_monitoring_app',
  data() {
    return {
      changelog: [
        {
          version: '1.0.0-beta',
          versionNumber: '1.0.1',
          buildDate: '2024-06-04',
          changeList: [
          ],
          current: true
        }
      ]
    }
  },
  computed: {
    current() {
      let vm = this
      let current = vm.changelog.find(element => element.current)
      return current
    },
    mode() {
      return this.$store.getters.mode
    }
  },
  created() {
    let vm = this
    vm.updateMetaTags()
    vm.$store.dispatch('setPageSelected', 'app')
    vm.$store.dispatch('validateVersion')
  },
  methods: {
    updateMetaTags() {
      let title = 'unMineable Monitoring App - Earn your favorite crypto coins!'
      document.title = title
      const metaTitle = document.querySelector('head meta[property="og:title"]');
      metaTitle.setAttribute('content', title);
    }
  }
}
</script>

<style lang="stylus" scoped>

.top-feature
  margin-bottom 10px
.img-miner
  width: 290px;
  box-shadow: 0px 0px 50px -20px #000;
  margin: 20px 0px;
  
.download-info
  .button.download-mfi
    background-color: #b6ffb6;
    color: #000;
    border-color: #7ba088;
  .button.download-mfi, .button.download-main
    width 100%


.new-feature-li
  list-style: circle;
  margin-left: 16px;
  font-size: 12px;
  color: #829286;
  &.bold
    font-weight 600
.changelog-download-version
  width auto
  margin-right 10px

.changelog-version
  padding: 10px 0px;
  font-size: 13px;
  font-weight: 700;

.changelog-detail-list
  li
    list-style: circle;
    margin-left: 16px;
    font-size: 12px;
    color: #292929;

.size-current
  margin-left 5px
  &.mfi
    font-size 11px
  &.main
    font-size 10px


html.dark, body.dark
  .feature-helvetica
    color: #fff;
  .download-info
    .button.download-mfi, .button.download-main
      color #000
      &:hover
        color #000
  .changelog-detail-list
    li
      color: #fff;
  .changelog-download-version
    color #000
  .articles
    a, span
      color: #fff;
    .article-mini
      .article-inner
        &:hover
          border solid 1px #fff

.mb-18
  margin-bottom 18px

.title-desc
  text-align left
  line-height 45px
  span
    font-size 2.1rem
  .title
    font-weight 600
   
.articles
  .article-mini
    cursor pointer
    color #4a4a4a
    padding 5px 0px
    width 100%
    display block
    .article-inner
      border-radius 5px
      border 1px solid #ccc
      padding: 7px 10px 5px 10px;
      display flex
      align-items center
      &:hover
        border solid 1px #8e8e8e
    .article-title
      flex 1
      span
        font-weight 400
    .article-content
      font-size: 12px;
      text-align: justify;
    .article-bottom
      font-size 13px
.get-app-image
  flex 1
  padding 5px 10px
  &.android
    img
      height 40px
</style>



// WEBPACK FOOTER //
// View_Monitoring_App.vue?0f39a4e3